import { createApp, defineAsyncComponent } from 'vue/dist/vue.esm-bundler';

const Map = defineAsyncComponent(() =>
  import('./components/Mapv2.vue')
);

const Navigation = defineAsyncComponent(() =>
  import('./components/Navigation.vue')
);

// const WeatherWidget = defineAsyncComponent(() =>
//   import('./components/WeatherWidget.vue')
// );

const Adminbar = defineAsyncComponent(() =>
   import('./components/AdminBar.vue')
);

const AlertBar = defineAsyncComponent(() =>
  import('./components/AlertBar.vue')
);

const EventCal = defineAsyncComponent(() =>
  import('./components/EventsCalendar.vue')
);

const Slider = defineAsyncComponent(() =>
  import('./components/Slider.vue')
);

// const Accordion = defineAsyncComponent(() =>
//   import('./components/Accordion.vue')
// );

/*--------------------------
   MAP
--------------------------*/
const mapApp = createApp({ 
   components: {Map},
});
mapApp.component('map-v2', Map);
mapApp.mount('#v_map_component');

/*--------------------------
   NAVIGATION
--------------------------*/
const navApp = createApp({ 
   components: {Navigation},
});
navApp.component('navigation', Navigation);
navApp.mount('#v_navigation_component');

/*--------------------------
   ALERT
--------------------------*/
const alertApp = createApp({ 
   components: {AlertBar},
});
alertApp.component('alert-bar', AlertBar);
alertApp.mount('#v_alertbar_component');

/*--------------------------
   EVENTS CALENDAR
--------------------------*/
const eventsApp = createApp({ 
   components: {EventCal},
});
eventsApp.component('events-calendar', EventCal);
eventsApp.mount('#v_events_component');

/*--------------------------
   SLIDER: Activities, events
--------------------------*/
const sliderApp = createApp({ 
   components: {Slider},
});
sliderApp.component('slider-main', Slider);
sliderApp.mount('#v_slider_component');

/*--------------------------
   ACCORDION
--------------------------*/
// const accordionApp = createApp({ 
//    components: {Accordion},
// });
// accordionApp.component('accordion', Accordion);
// accordionApp.mount('#v_accordion_component');

/*--------------------------
   ADMIN BAR
--------------------------*/
const adminbarApp = createApp({ 
   components: {Adminbar},
});
adminbarApp.component('adminbar', Adminbar);
adminbarApp.mount('#v_adminbar_component');